/**
 * EthereumWalletContext context instance and type definition.
 * Separated from EthereumWalletContext.tsx so hooks can live in their own file
 * without triggering react-refresh/only-export-components warnings.
 */

import { createContext } from 'react';
import type { Address } from 'viem';

export interface EthereumWalletContextType {
  // Connection state
  address: Address | undefined;
  isConnected: boolean;
  isConnecting: boolean;
  chainId: number | undefined;

  // Multi-chain wrong network detection
  isWrongNetwork: boolean;
  expectedChainId: number | null;

  // Actions
  openConnectModal: () => void;
  disconnect: () => void;
  switchToSelectedChain: () => Promise<void>;

  // Legacy action (deprecated)
  /** @deprecated Use switchToSelectedChain instead */
  switchToSepolia: () => Promise<void>;

  // Chain switching state
  isSwitchingChain: boolean;

  // Balance (for the selected chain)
  balance: string | undefined;
  balanceSymbol: string | undefined;
}

export const EthereumWalletContext = createContext<EthereumWalletContextType | null>(null);
